import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, Box } from "@mui/material";
import Alert from "@mui/material/Alert";

function OpenTripForm2({ nextStep, handleChange, values }) {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const formIsValid = () => {
    const formErrors = {};

    if (!values.tripid) formErrors.tripid = "Trip Id is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    navigate(`${process.env.PUBLIC_URL}/ivr`, {
      state: { trip_id: values.vtr_nbr, vesselNbr: values.permitNbr },
    });
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <TextField
          name="trip_id"
          label="Trip Id:"
          className="number-of-input"
          type="number"
          placeholder="Trip Id"
          variant="standard"
          defaultValue={values.tripid}
          onChange={handleChange("trip_id")}
          required={true}
          inputProps={{ style: { textAlign: "center" } }}
        />
      </Box>
      {errors.tripid && <Alert severity="error">{errors.tripid}</Alert>}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Cancel
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default OpenTripForm2;
